module.exports = __webpack_public_path__ + "img/IMG_1024_L_WoodMatted.be80e1eb.jpg";